import { UserId } from '@business/entities/account';
import { FCData, FCFormDataType } from '@modules/statistics/StatCollection/FormFields/types';

export type StatId = string;
export type StatBatchId = string;
export type StatReportId = string;

export interface StatResponse {
  id: StatId;
  title: string;
  frequency: FrequencyType;
  sendTime: string;
  fromName: string;
  day: string;
  emailContent: string;
  fields: FCFormDataType[];
  timeZone: string;
  sendDay: WeekDays;
  closeDay: WeekDays;
  closeTime: string;
  recipients: UserId[];
  recipientsEmails: string[];
  email: string;
}

export interface StatReportResponse {
  id: StatReportId;
  recipient: string;
  fields: FCFormDataType[];
  note: string;
  completed: number;
  completed_at: number;
}

export enum FrequencyType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
}

export enum GraphKind {
  regular = 'regular',
  equation = 'equation',
  combination = 'combination',
}

export enum GraphScalingType {
  auto = 'auto',
  custom = 'custom',
}

export type DaysOfOperation = { [key in WeekDays]: boolean };

export enum WeekDays {
  sunday = 'sunday',
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
}

export enum DayTime {
  '00:00' = '00:00',
  '01:00' = '01:00',
  '02:00' = '02:00',
  '03:00' = '03:00',
  '04:00' = '04:00',
  '05:00' = '05:00',
  '06:00' = '06:00',
  '07:00' = '07:00',
  '08:00' = '08:00',
  '09:00' = '09:00',
  '10:00' = '10:00',
  '11:00' = '11:00',
  '12:00' = '12:00',
  '13:00' = '13:00',
  '14:00' = '14:00',
  '15:00' = '15:00',
  '16:00' = '16:00',
  '17:00' = '17:00',
  '18:00' = '18:00',
  '19:00' = '19:00',
  '20:00' = '20:00',
  '21:00' = '21:00',
  '22:00' = '22:00',
  '23:00' = '23:00',
}
